export default {
  creds: (state) => state.creds,
  session: (state) => state.session,
  codeChallenge: (state) => state.codeChallenge,
  sessionExpiration: (state) => state.sessionExpiration,
  impBrokerage: (state) => state.impBrokerage,
  impUser: (state) => state.impUser,
  impLoanOffice: (state) => state.impLoanOffice,
  isAuthing: (state) => state.isAuthing,
  isReAuthing: (state) => state.isReAuthing,
  isAuthingBroker: (state) => state.isAuthingBroker,
  sessionAutoRefresh: (state) => state.sessionAutoRefresh,
  sessionExpiresIn: (state) => {
    let now = new Date();
    let exp = new Date(state.sessionExpiration);
    return (exp.getTime() - now.getTime()) / 1000;
  },
  // getter that allows passing of product param as a string to check if array contains that product
  impBrokerageHasProduct: (state) => (product) => {
    return state.impBrokerage.product.some((p) => p.productFamily === product);
  },
};
